<template>
  <span :class="{ 'dh-psy-tooltip__trigger': true, 'dh-psy-tooltip__trigger--visible': visible }">
    <button
      class="nrk-unset"
      ref="btn"
      @mouseover="handleMouseOver"
    ><span class="dh-psy-tooltip__trigger-content">{{ content }}</span><sup aria-hidden>?</sup></button>
    <div
      :class="{'dh-psy-tooltip': true, 'dh-psy-tooltip--error': termContent === false }"
      hidden
      :style="tooltipStyle"
    >
      <div class="dh-psy-tooltip__content">
        <dl v-if="termContent && termContent.description">
          <dt
            v-if=" termContent.title"
            v-html="termContent.title"
          />
          <dd v-html="termContent.description" />
        </dl>
        <div v-else-if="termContent !== false">Laster...</div>
      </div>
    </div>
    <span class="dh-psy-tooltip__arrow">
      <svg viewBox="0 0 100 100">
        <polygon
          points="50,0 100,100 0,100"
          fill="white"
        />
      </svg>
    </span>
  </span>
</template>

<style scoped lang="postcss">
  .dh-psy-tooltip__trigger {
    position: relative;
    margin: 0;
    padding: 0;
    white-space: nowrap;
    cursor: pointer;

    & button {
      outline: none;
      margin-right: -5px;
    }
    & .dh-psy-tooltip__trigger-content {
      position: relative;

      &:before {
        content: '';
        position: absolute;
        top: 5px;
        bottom: 5px;
        left: 0;
        right: 0;
        background-color: #e2e2e2;
        transition: background-color 0.2s ease-in-out;
        z-index: -1;
      }
    }

    & .dh-psy-tooltip__trigger-content:hover {
      &:before {
        background-color: #ccc;
      }
    }

    & sup {
      font-weight: 600;
      padding: 0 2px;
      color: #14a081;
    }

    &.dh-psy-tooltip__trigger--visible {
      & .dh-psy-tooltip__trigger-content:before {
        background-color: #8debd6;
      }
      & sup {
        color: inherit;
      }
    }
  }

  .dh-psy-tooltip {
    position: absolute;
    width: 300px;
    padding: 0;
    cursor: auto;

    &.dh-psy-tooltip--error {
      display: none;
    }
  }

  .dh-psy-tooltip__arrow {
    position: absolute;
    bottom: -3px;
    left: calc(50% - 5px);
    width: 6px;
    height: 6px;
  }

  .dh-psy-tooltip__arrow svg {
    position: absolute;
    top: 0;
    left: 0;
  }

  .dh-psy-tooltip__arrow,
  .dh-psy-tooltip {
    transition: 0.2s opacity ease;
    z-index: 1;
  }

  .dh-psy-tooltip[hidden] {
    display: block;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;

    & + .dh-psy-tooltip__arrow {
      opacity: 0;
    }
  }

  .dh-psy-tooltip__content {
    box-sizing: border-box;
    padding: 18px;
    background: #fff;
    border: 1px solid #e2e2e2;
    z-index: 1;
    white-space: normal;
    line-height: 1.5;
  }

  dl {
    font-size: 16px;
    margin: 0;
  }

  dt {
    font-weight: bold;
    margin-bottom: 10px;
  }

  dd {
    margin: 0;
  }
</style>

<script>
import { findTerm } from '../../../../content/terms/find-term'
import globalEventStore from '../../../../lib/global-event-store'

import coreToggle from '@nrk/core-toggle'

export default {
  props: ['content'],
  data() {
    return {
      visible: false,
      maxWidth: 300,
      left: 0,
      margin: 10,
      termContent: null
    }
  },
  computed: {
    hidden() {
      return !this.visible
    },
    tooltipStyle() {
      return {
        width: `${this.maxWidth - this.margin}px`,
        left: `${this.left - this.margin}px`
      }
    }
  },
  mounted() {
    coreToggle(this.$refs.btn, { popup: true })

    document.body.addEventListener('toggle', this.handleToggle)
  },
  methods: {
    handleToggle(e) {
      if (e.target === this.$refs.btn) {
        this.handleMouseOver()
        this.visible = e.detail.willOpen
        const nextState = e.detail.willOpen ? 'OPEN' : 'CLOSE'
        globalEventStore.dispatch(this.$root.$data.id, 'sendGaEvent', {
          action: `TOGGLE_TERM/${this.content}/${nextState}`
        })
      }
    },
    handleMouseOver() {
      if (this.termContent === null) this.loadTerm()
      this.setPosition()
    },
    setPosition() {
      const rect = this.$refs.btn.getBoundingClientRect()
      const marginRight = window.innerWidth - rect.x - this.maxWidth
      this.left = Math.min(marginRight, 0)
    },
    loadTerm() {
      findTerm(this.content).then(termContent => {
        if (termContent) {
          this.termContent = termContent
          globalEventStore.dispatch(this.$root.$data.id, 'sendGaEvent', {
            action: `LOAD_TERM_SUCCESS/${this.content}`
          })
        } else {
          this.termContent = false
          globalEventStore.dispatch(this.$root.$data.id, 'sendGaEvent', {
            action: `LOAD_TERM_FAIl/${this.content}`
          })
        }
      })
    }
  }
}
</script>
